import { Slot } from '@radix-ui/react-slot'
import { VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/lib/utils'
import { ButtonVariants, ButtonVariantType } from './variants'

type VariantPropsByType = {
  [K in ButtonVariantType]: {
    variantType?: K
  } & VariantProps<typeof ButtonVariants[K]>
}

type ButtonBaseProps = {
  asChild?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement>

// Union of all variant combinations with proper inference
export type ButtonProps = ButtonBaseProps &
  VariantPropsByType[keyof VariantPropsByType]

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variantType = 'base',
      variant,
      size,
      asChild = false,
      fullWidth,
      ...props
    },
    ref
  ) => {
    const Comp = asChild ? Slot : 'button'
    const cvaFn = ButtonVariants[variantType]

    return (
      <Comp
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        className={cn(cvaFn({ variant, size, className, fullWidth } as any))}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = 'Button'

export { Button }
